import { Outlet } from "react-router-dom";
import { usePageContext } from "~/contexts/page-context";
import { AdminSidebar } from "./AdminSidebar";

// Declared once for the whole section rather than per page: which admin screen
// is open says little the agent can act on, and naming each one would put a map
// of routes back in the app.
export const AdminLayout = () => {
  usePageContext({ page: "admin" });

  return (
    <div className="flex h-full overflow-hidden">
      <AdminSidebar />
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};
